// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "NHÌN LẠI NĂM CŨ",
    "note": "*Tất cả số liệu thống kê trong bản xem xét này là tính đến ngày 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nBạn đã chơi KKPoker lần đầu tiên trong năm 2025."
  },
  "report": {
    "loginTime": "Kể từ đó, \nKKPoker đã đồng hành cùng bạn trong \n{loginDay}",
    "loginTips": "*Số ngày đăng nhập vào KKPoker trong năm 2025.",
    "enjoyTime": "{loginTime}\nlà khoảng thời gian ưa thích nhất trong ngày của bạn! Đây là thời gian yêu thích của bạn để mở KKPoker!",
    "firstHandDate": "{first_hand_date}\nBạn đã nhận được tay bài đầu tiên trong năm khi chơi {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "Năm nay trong KKPoker,\nbạn đã chơi tổng cộng\n{hands}\nTình yêu với poker của bạn trội hơn \n{percentage} số người chơi.",
    "v2": "Năm nay trong KKPoker,\nbạn đã chơi tổng cộng\n{hands}\nCám ơn bạn vì đã trở thành một phần trong hành trình của chúng tôi!",
    "v3": "Năm nay trong KKPoker,\nbạn đã chơi tổng cộng \n{hands}\nKKPoker sẽ phấn đấu cải thiện và mang đến cho bạn nhiều trải nghiệm thú vị hơn nữa trong năm tới!"
  },
  "hardTime": {
    "date": "{one_day_hands}\nĐây là ngày bạn dành nhiều thời gian nhất cho KKPoker.",
    "hands": "Hôm đó, bạn đã chơi tổng cộng\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "Trong tổng số ván bài của bạn,\n{handsNum} {hands} đã được chơi \ntheo thể thức ván đấu yêu thích của bạn {game}.",
  "kkWin": {
    "v1": "Trong năm 2025, bạn đã nhận được KK tổng cộng\n{all} {longTimes}\nvà dùng KK để đánh bại đối thủ\n{win} {longTimesTwo}",
    "v2": "Trong năm nay, bạn đã chơi tất tay\n{all} {threeTimes}\nTỷ lệ Tất tay của bạn:\n{percentage}\nPoker là trò chơi dành cho người dũng cảm!"
  },
  "achievement": {
    "spinup": "{spinup_date}\nlà ngày may mắn nhất của bạn.",
    "spinup_2": "Hôm đó, bạn đã quay được {spinup_ratio} hệ số trong SpinUp và thắng\n{spinup_reward}",
    "mtt": "{mtt_date}\nlà tâm điểm trong năm của bạn.",
    "mtt_2": "Hôm đó,\nbạn xếp hạng {no} {mtt_rank} trên {mtt_name}\nvà thắng\n{mtt_reward}",
    "rg": "{rg_date}\nMột ngày đáng nhớ trong hành trình chơi poker của bạn!",
    "rg_2": "Hôm đó, bạn đã thắng mức tiền gà lớn nhất trong năm:\n{rg_reward}"
  },
  "lucky": {
    "title": "Mỗi ván bài lại kể\ncâu chuyện riêng.",
    "luckyHand": "VÁN BÀI\nMAY MẮN",
    "unLuckyHand": "VÁN BÀI\nĐEN ĐỦI",
    "luckyRate": "Tỷ lệ thắng\n{lucky_rate}",
    "unLuckyRate": "Tỷ lệ thắng\n{unlucky_rate}",
    "luckyText": "{lucky_hand} trở thành vị cứu tinh.\nBạn thắng tới {lucky_rate}% mỗi khi sở hữu nó!",
    "unLuckyText": "Cẩn thận với {unlucky_hand}…\nBạn chỉ thắng {unlucky_rate} mỗi khi sở hữu nó.",
    "note": "*Chỉ những ván bài khởi đầu được chia từ 10 lần trở lên mới đủ điều kiện."
  },
  "futureStory": "KKPoker muốn tiếp tục viết nên câu chuyện về hành trình poker cùng bạn trong năm 2026.",
  "version3": {
    "text": "Thật đáng tiếc, bạn không có nhiều kỉ niệm với KKPoker trong năm 2025.",
    "continue": "Hãy ghi lại chương kế tiếp\ntrên hành trình KKPoker của bạn trong năm 2026!"
  },
  "button": {
    "save": "NHÌN LẠI NĂM CŨ",
    "copy": "Sao chép và Chia sẻ"
  },
  "unit": {
    "days": "ngày",
    "hands": "ván bài",
    "longHands": "ván bài",
    "longTimes": "lần",
    "longTimesTwo": "lần",
    "threeTimes": "lần",
    "times": "lần",
    "multiplier": "hệ số ",
    "num": "Số ",
    "num2": "",
    "bets": "",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "Đã sao chép liên kết"
  }
}
  